import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RelaxationService {
  private readonly _removedToken$ = new BehaviorSubject<string>('');

  removedToken$: Observable<string> = this._removedToken$;

  setRemovedToken(removedToken: string) {
    this._removedToken$.next(removedToken);
  }
}
